import FormValidator from "base/FormValidator";
import EventEmitter from "base/EventEmitter";
import Ajax from "base/Ajax";

class AddressEditor extends EventEmitter {

    constructor(data = null, user = null) {
        super();
        this.href = data === null ? null : data.href;
        this.user = user;
        this.data = data;
        this.exists = data !== null;

        this.buildEditor();
        this.buildListItem();
        this.bindEvents();
        if (data !== null) {
            this.updateInputs();
        }
        this.updateData();
    }

    get user() {
        return this._user;
    }

    set user(user) {
        this._user = user;
        if (user !== null && this.href === null) this.href = user.href + "/addresses";
    }

    getListItem() {
        setTimeout(() => this.$listItem.data("address", this));
        return this.$listItem;
    }

    updateData() {
        this.data = this.$element.serializeJSON();
        this.data.isDefaultShipping = this.data.isDefaultBilling = "undefined" !== typeof this.data.isDefaultBilling;

        this.updateListItem();
    }

    updateListItem() {
        this.$listItem.find("p").remove().end()
            .append(eotwJSXFactory('p', null, [[this.data.title, this.data.firstName, this.data.lastName].join(" ").trim().replace(/ {2}/g, " ")]))
            .append(eotwJSXFactory('p', null, [this.data.address1]))
            .append(eotwJSXFactory('p', null, [this.data.postcode]));
        this.updateListDefault();
    }


    updateListDefault() {
        this.$listItem.toggleClass("admin-address-list__item--default", this.data !== null && (this.data.isDefaultShipping || this.data.isDefaultBilling))
    }

    updateInputs() {
        $.each(this.data, (key, val) => {
            this.$element.find("input[name='" + key + "']").val(val);
        });
        this.$element.find("input[name='isDefaultBilling']").prop("checked", this.data.isDefaultBilling);
        this.updateListItem();
    }

    save() {
        return Ajax.post(null, this.href, this.data).then((data) => {
            this.exists = true;
            this.data = data;
            this.href = data.href;
            this.updateInputs();
            this.updateData();
        })
    }

    _delete() {
        return Ajax.delete(null, this.href);
    }

    bindEvents() {
        const me = this;
        FormValidator.attach(this.$element).on("submit", () => {
            this.emit('submit');
        });

        this.$element.on("keyup change", "input", this.updateData.bind(this)).on("change", "input[name='isDefaultBilling']", function () {
            if ($(this).is(":checked")) {
                me.emit("defaultBilling", true);
            }
        });
    }

    buildListItem() {
        this.$listItem = (
            eotwJSXFactory('div', {class: "admin-address-list__item js-select-address"}, [
                eotwJSXFactory('buttom', {class: "js-remove-address admin-address-list__item__remove"})
            ])
        );
    }

    buildEditor() {
        this.$element = (
            eotwJSXFactory('form', {class: "admin-form__col admin-form__col--flex"}, [
                eotwJSXFactory('div', {class: "admin-form__row admin-form__row--third"}, [
                    eotwJSXFactory('label', {class: "admin-form__label"}, ["Title"]),
                    eotwJSXFactory('input', {'data-optional': true, class: "admin-form__input", name: "title"}),
                    eotwJSXFactory('span', {class: "form__inline-validation js-inline-validation"})
                ]),
                eotwJSXFactory('div', {class: "admin-form__row admin-form__row--third"}, [
                    eotwJSXFactory('label', {class: "admin-form__label"}, ["First Name *"]),
                    eotwJSXFactory('input', {class: "admin-form__input", name: "firstName"}),
                    eotwJSXFactory('span', {class: "form__inline-validation js-inline-validation"})
                ]),
                eotwJSXFactory('div', {class: "admin-form__row admin-form__row--third"}, [
                    eotwJSXFactory('label', {class: "admin-form__label"}, ["Last Name *"]),
                    eotwJSXFactory('input', {class: "admin-form__input", name: "lastName"}),
                    eotwJSXFactory('span', {class: "form__inline-validation js-inline-validation"})
                ]),
                eotwJSXFactory('div', {class: "admin-form__row admin-form__row--half"}, [
                    eotwJSXFactory('label', {class: "admin-form__label"}, ["Address 1 *"]),
                    eotwJSXFactory('input', {class: "admin-form__input", name: "address1"}),
                    eotwJSXFactory('span', {class: "form__inline-validation js-inline-validation"})
                ]),
                eotwJSXFactory('div', {class: "admin-form__row admin-form__row--half"}, [
                    eotwJSXFactory('label', {class: "admin-form__label"}, ["Address 2"]),
                    eotwJSXFactory('input', {'data-optional': true, class: "admin-form__input", name: "address2"}),
                    eotwJSXFactory('span', {class: "form__inline-validation js-inline-validation"})
                ]),
                eotwJSXFactory('div', {class: "admin-form__row admin-form__row--half"}, [
                    eotwJSXFactory('label', {class: "admin-form__label"}, ["Town *"]),
                    eotwJSXFactory('input', {class: "admin-form__input", name: "town"}),
                    eotwJSXFactory('span', {class: "form__inline-validation js-inline-validation"})
                ]),
                eotwJSXFactory('div', {class: "admin-form__row admin-form__row--half"}, [
                    eotwJSXFactory('label', {class: "admin-form__label"}, ["County"]),
                    eotwJSXFactory('input', {'data-optional': true, class: "admin-form__input", name: "county"}),
                    eotwJSXFactory('span', {class: "form__inline-validation js-inline-validation"})
                ]),
                eotwJSXFactory('div', {class: "admin-form__row admin-form__row--half"}, [
                    eotwJSXFactory('label', {class: "admin-form__label"}, ["Post Code *"]),
                    eotwJSXFactory('input', {class: "admin-form__input", name: "postcode"}),
                    eotwJSXFactory('span', {class: "form__inline-validation js-inline-validation"})
                ]),
                eotwJSXFactory('div', {class: "admin-form__row admin-form__row--center admin-form__row--half"}, [
                    eotwJSXFactory('label', {class: "admin-form__label admin-form__label--smargin"}, [
                        eotwJSXFactory('input', {'data-optional': true, type: "checkbox", class: "admin-form__radio-checkbox", name: "isDefaultBilling"}),
                        "Default Address?"
                    ])
                ]),
                eotwJSXFactory('input', {type: "submit", style: "display:none;"})
            ])
        );
    }

    validate() {
        return this.$element.data("Validator").validate();
    }

}

export default AddressEditor;
